import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

//编辑角色名称
export const requesteditrolename = async params => {
    const res = await axios({ method: 'post', url: `${base}/role/editrole`, params: params });
    return res.data;
};
//删除角色
export const requestdelrole = async params => {
    const res = await axios({ method: 'post', url: `${base}/role/delrole`, params: params });
    return res.data;
};
//所有角色列表
export const requestrolelist = async params => {
    const res = await axios({ method: 'post', url: `${base}/role/rolelist`, params: params });
    return res.data;
};
//查询角色详情
export const requestroleinfo= async params => {
    const res = await axios({ method: 'post', url: `${base}/role/roleinfo`, params: params });
    return res.data;
};
//给角色保存权限
export const requestsaverolepermissions= async params => {
    const res = await axios({ method: 'post', url: `${base}/role/saverolepermissions`, params: params });
    return res.data;
};
//通过角色id查询角色下人员
export const requestqueryuserbyrole= async params => {
    const res = await axios({ method: 'post', url: `${base}/role/queryuserbyrole`, params: params });
    return res.data;
};

//删除角色下人员
export const requestdeleteuserfromrole= async params => {
    const res = await axios({ method: 'post', url: `${base}/role/deleteuserfromrole`, params: params });
    return res.data;
};



